const wstApplyMainRoutes = Array.from({ length: 18}, (_, i) => ({
  path: `apply/wst/index${i + 1}`,
  name: `applyWstIndex${i + 1}`,
  component: () => import(`@/views/health/apply/wst/index${i + 1}.vue`),
}));


export default {
  path: "/health",
  component: { render: (c) => c("router-view") },
  children: [
    // 预约挂号——皖事通，主流程
    ...wstApplyMainRoutes,
  ],
};
